import { render, staticRenderFns } from "./CitaFirma.vue?vue&type=template&id=0d2647d6&scoped=true"
import script from "./CitaFirma.vue?vue&type=script&lang=js"
export * from "./CitaFirma.vue?vue&type=script&lang=js"
import style0 from "./CitaFirma.vue?vue&type=style&index=0&id=0d2647d6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2647d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d2647d6')) {
      api.createRecord('0d2647d6', component.options)
    } else {
      api.reload('0d2647d6', component.options)
    }
    module.hot.accept("./CitaFirma.vue?vue&type=template&id=0d2647d6&scoped=true", function () {
      api.rerender('0d2647d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/formalizacionactas/citafirma/CitaFirma.vue"
export default component.exports